import { createSwitch } from '@/utils'

export const useUserItemMenu = (onRestore: () => void) => {
  const switcher = createSwitch().case(['restore'], onRestore)

  const onClick = (keys: string[]) => switcher.run(keys)

  return {
    onClick,
  }
}
